<template>
  <b-modal ref="modal" hide-footer title="Suppression Details" size="lg">
    <p>
      It’s crucial that suppressions are carried out correctly. They can affect
      both your department and others across the business. Since the
      introduction of GDPR you need to be clear on what you are suppressing and
      your reasons for the suppressions.
    </p>

    <p>
      You have decided to suppress
      <strong>{{ company.companyName }}</strong> to
      <strong>{{ suppressionString }}</strong> currently this is only applied to
      your department.
    </p>

    <p>
      Does this company need to be suppressed across the entirety of the K3
      Capital Group?
    </p>

    <p class="italics">
      For Example – If a client states they are not looking to sell, please stop
      contacting me, then only remove from Globe. THEY HAVE NOT ASKED FOR THEIR
      DETAILS TO BE REMOVED COMPLETELY.
    </p>

    <b-form-radio v-model="isGlobal" :value="false">
      No - this business only needs to be suppressed for my department
    </b-form-radio>

    <b-form-radio v-model="isGlobal" :value="true">
      Yes - this business needs to be suppressed across the entire K3 Group
    </b-form-radio>

    <b-row class="my-1">
      <b-col md="9"> </b-col>
      <b-col md="3">
        <b-button class="mt-3" variant="success" block :disabled="isGlobal == null" @click="saveSuppression">
          Save
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import CompanyService from "@/services/Company.service";
import DataSelectionService from '@/services/DataSelection.service';

export default {
  props: {
    company: Object
  },
  data() {
    return {
      isGlobal:null
    };
  },
  computed: {
    suppressionString() {
      var str = "";

      if (this.company == null) return "";

      if (this.company.doNotCall) str += "Do Not Call, ";
      if (this.company.doNotMail) str += "Do Not Mail, ";
      if (this.company.doNotEmail) str += "Do Not Email, ";

      if (str != "") {
        str = str.substring(0, str.length - 2);
      } else {
        str = "nothing";
      }
      return str;
    },
  },
  methods: {
    showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
    saveSuppression() {
      //this.$parent.$parent.$parent.$parent.loadData();
      var suppression = {
        companyId: this.company.id,
        suppressPhone: this.company.doNotCall,
        suppressMail: this.company.doNotMail,
        suppressEmail: this.company.doNotEmail,
        isGlobal: this.isGlobal
      }
      CompanyService.saveSuppression(suppression).then(() => {

        if(this.$route.name == "CompanyCall") {
          DataSelectionService.getNextCompany().then(result => {
            if(result && result.data != 0) {
              this.$router.push("/call/" + result.data);
            } else {
              this.$router.push("/getnext");
            }
          });
        } else {
          this.isBusy = false;
          this.$parent.$parent.$parent.$parent.loadData();
          this.hideModal();
        }
      });

    },
  },
};
</script>

<style scoped>
</style>
